import { makeStyles } from '@material-ui/core';

import { neutral } from '../../../shared/styles/colors';

export default makeStyles({
  root: {
    alignItems: 'center',
    display: 'grid',
    gridTemplateColumns: 'min-content min-content min-content',
    columnGap: '0.75rem',
    width: '12.5rem',
    gap: '0.5rem',
  },
  value: {
    color: neutral[80],
    fontFamily: 'PP Object Sans',
    fontSize: '1.25rem',
    fontWeight: 700,
  },
  valueContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '1.25rem',
  },
});
